import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Never trust editable user metadata or an email embedded in the frontend.
export function useAdministrator(): boolean {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    let disposed = false;
    let revision = 0;
    const check = async () => {
      const current = ++revision;
      setAllowed(false);
      try {
        const { data, error } = await supabase.rpc("is_table_read_administrator" as never);
        if (!disposed && current === revision) setAllowed(!error && data === true);
      } catch { /* Fail closed, including during sign-out and connectivity loss. */ }
    };
    void check();
    const { data: { subscription } } = supabase.auth.onAuthStateChange(() => {
      setAllowed(false);
      // Run outside Supabase's auth callback lock.
      queueMicrotask(() => { if (!disposed) void check(); });
    });
    const onFocus = () => void check();
    window.addEventListener("focus", onFocus);
    const timer = window.setInterval(onFocus, 60_000);
    return () => { disposed = true; revision++; subscription.unsubscribe(); window.removeEventListener("focus", onFocus); window.clearInterval(timer); };
  }, []);
  return allowed;
}
